import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiRefreshCw, FiShare2, FiCheck } = FiIcons;

const ResultScreen = ({ result, onRestart }) => {
  const [copied, setCopied] = React.useState(false);

  const handleShare = async () => {
    const shareText = `🎯 I just took the AI Personality Quiz!\n\n${result.emoji} ${result.title}\n\n${result.description}\n\nTry it yourself!`;
    
    try {
      await navigator.clipboard.writeText(shareText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      className="min-h-screen flex items-center justify-center p-6"
    >
      <div className="bg-white/90 backdrop-blur-lg rounded-3xl p-8 max-w-md w-full text-center shadow-2xl">
        {/* Result Emoji */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring" }}
          className="text-8xl mb-6"
        >
          {result.emoji}
        </motion.div>

        {/* Result Title */}
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="text-3xl font-bold text-gray-800 mb-4"
        >
          {result.title}
        </motion.h2>

        {/* Result Description */}
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="text-gray-600 mb-8 leading-relaxed"
        >
          {result.description}
        </motion.p>

        {/* Action Buttons */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8 }}
          className="space-y-4"
        >
          <button
            onClick={handleShare}
            className="w-full bg-gradient-to-r from-green-500 to-emerald-500 text-white px-6 py-4 rounded-full font-semibold text-lg flex items-center justify-center gap-3 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
          >
            <SafeIcon icon={copied ? FiCheck : FiShare2} className="text-xl" />
            {copied ? 'Copied to Clipboard!' : 'Share Result'}
          </button>

          <button
            onClick={onRestart}
            className="w-full bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-4 rounded-full font-semibold text-lg flex items-center justify-center gap-3 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
          >
            <SafeIcon icon={FiRefreshCw} className="text-xl" />
            Take Quiz Again
          </button>
        </motion.div>

        {/* Fun Fact */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
          className="mt-6 p-4 bg-purple-50 rounded-xl"
        >
          <p className="text-sm text-purple-700 font-medium">
            🎭 Fun Fact: {result.funFact}
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ResultScreen;